export default {
  "content": "<path fill=\"none\" d=\"M0 0h16v16H0z\" data-name=\"Bounding box\"/><path d=\"M13.387 2.163L8.531.18a1.4 1.4 0 00-1.062 0L2.613 2.163A.985.985 0 002 3.075v7.815a2.3 2.3 0 001.1 1.937L7.305 15.6a1.263 1.263 0 001.39 0l4.205-2.773A2.3 2.3 0 0014 10.89V3.075a.985.985 0 00-.613-.912zm-2.553 4.388l-2.642 4A1 1 0 017.4 11h-.042a1 1 0 01-.785-.381L5.215 8.9a1 1 0 111.57-1.239l.5.637 1.881-2.849a1 1 0 011.668 1.1z\" fill=\"#3f4450\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 16 16"
  }
};